import React from 'react';
import dayjs from 'dayjs';

import { CalendarDayProps } from '../../types';

import { Container } from './styles';

export const CalendarDay = ({
  date,
  onClick,
  currentMonth,
  selectedFromDate,
}: CalendarDayProps) => {
  const isCurrentDay = date.isSame(dayjs(), 'day');

  const isCurrentMonth = date.isSame(dayjs.unix(currentMonth), 'month');

  const isInSelectedWeek = React.useCallback(() => {
    if (selectedFromDate) {
      const startOfWeek = dayjs.unix(selectedFromDate).startOf('week');
      const endOfWeek = dayjs.unix(selectedFromDate).endOf('week');

      if (date.isSame(startOfWeek) || date.isSame(endOfWeek)) {
        return true;
      }

      if (date.isBetween(startOfWeek, endOfWeek)) {
        return true;
      }
    }

    return false;
  }, [date, selectedFromDate]);

  const handleDayClick = React.useCallback(() => {
    if (onClick) {
      onClick({
        startDate: dayjs(date).startOf('week').unix(),
        endDate: dayjs(date).endOf('week').unix(),
      });
    }
  }, [date, onClick]);

  return (
    <Container
      onClick={handleDayClick}
      isCurrentDay={isCurrentDay}
      isCurrentMonth={isCurrentMonth}
      isInSelectedWeek={isInSelectedWeek()}
    >
      <p>{date.date()}</p>
    </Container>
  );
};
